// import { useCallback } from 'react';
import { Handle, Position, NodeToolbar } from "@xyflow/react";
import { useGraphStore } from "./store";
import { useMemo } from "react";
// import { userIsLogged, getRoute, apiGetAvpAssistenteById, apiGetAllSysLingue, apiGetAvpGrafo, apiGetAvpNodoTipoAvvio, apiPostAvpArcoAdd, apiPostAvpNodoAdd, apiDeleteAvpNodo, apiPostAvpNodoAvatar, apiGetAvpNodoDuplica } from "../shared/manager/api_manager";
import { useLingueStore } from "../../sistema/storeLingua";
import {
  userIsLogged,
  getRoute,
  apiGetAvpAssistenteById,
  apiGetAllSysLingue,
  apiGetAvpGrafo,
  apiGetAvpNodoTipoAvvio,
  apiPostAvpArcoAdd,
  apiPostAvpNodoAdd,
  apiDeleteAvpNodo,
  apiPostAvpNodoAvatar,
  apiGetAvpNodoDuplica,
} from "../../shared/manager/api_manager";

//
function CustomNode({ id, data, isConnectable }) {
  const { selectedNode, aggiornaAvp, avp, selectedLingua,updateHiddenNode } = useGraphStore(
    (state) => state
  );

    const { selectedLinguaTesto } = useLingueStore(
      (state) => state
    );

  const isSelected = useMemo(() => {
    return selectedNode && String(selectedNode.idNodo) === id;
  }, [selectedNode, id]);

  const handleHideNode =()=>
  {
    updateHiddenNode(id)
    aggiornaAvp(avp.idAvp);

  }
  const getBackgruondColor = useMemo(() => {
    if (data.nodoStart) return "#00FF7F";
    if (isSelected) {
      return "yellow";
    }
    return "white";
  }, [isSelected, data]);

  function handleAdd() {
    if (selectedNode != null) {
      let tmpNode = {
        idAvp: avp.idAvp,
        descNodo:selectedLinguaTesto?.CustomNodeNewNodeText,
        nodoStart: false,
        tipoAvvio: 1,
        apiEsterna: "",
        formato: "",
        flagGoBack: false,
        sysUser: "",
        sysDate: new Date().toISOString(),
        sysAttivo: true,
      };
      apiPostAvpNodoAdd(tmpNode, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          let newNode = response.data;
          if (newNode != null) {
            let tmpArco = {
              formato: "",
              idLingua: selectedLingua.idLingua,
              // idLingua: (avp.lingue != null && avp.lingue.length > 0 ? avp.lingue[0].idLingua : null),
              idNodoStart: selectedNode.idNodo,
              idNodoEnd: newNode.idNodo,
              ordine: 1,
              testo: selectedLinguaTesto?.CustomNodeNewArcText,
            };
            apiPostAvpArcoAdd(tmpArco, function (response) {
              if (
                response != null &&
                response.status >= 200 &&
                response.status < 400
              ) {
                aggiornaAvp(avp.idAvp);
              }
            });
          }
        }
      });
    }
  }
  function handleDuplicate() {
    if (selectedNode != null) {
      apiGetAvpNodoDuplica(selectedNode.idNodo, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          aggiornaAvp(avp.idAvp);
        }
      });
    }
  }
  function handleDelete() {
    if (selectedNode != null) {
      apiDeleteAvpNodo(selectedNode.idNodo, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          aggiornaAvp(avp.idAvp);
        }
      });
    }
  }

  return (
    <div
      style={{
        border: 16,
        borderStyle: "solid",
        borderRadius: 10,
        paddingBlock: 10,
        minWidth: 100,
        maxWidth: 300,
        borderColor:data.nonAttivo?"#CCCCCC":"black",
        backgroundColor: getBackgruondColor,
        textAlign: "center",
        zIndex: 10,
        position: "relative",
        
      }}
      className={
        "text-updater-node  border-4 min-w-20 max-w-40 max-h-40 p-2 rounded-lg "
      }
    >
        {data.terminaSessione &&<img src="/images/back_img.svg" style={{width:22,position:"absolute",top:2,right:2}}  title={selectedLinguaTesto?.CustomNodeImgRestartSession}  />}
      
      <NodeToolbar
      
      isVisible={isSelected}
      position={Position.Top}
      style={{background:"none"}}
      
      >
        {!data.nodoStart &&<>
        <img src="/images/add_node_btn.svg" style={{width:22}} title={selectedLinguaTesto?.CustomNodeNewArcImgAdd} onClick={handleAdd} />
        <img src="/images/duplicate_node_btn.svg" style={{width:22}} title={selectedLinguaTesto?.CustomNodeNewArcImgDuplicate} onClick={handleDuplicate} />
        <img src="/images/delete_btn.svg" style={{width:22}} title={selectedLinguaTesto?.CustomNodeNewArcDelete} onClick={handleDelete} />
        <img src="/images/preview_btn.svg" style={{width:22}} title={selectedLinguaTesto?.CustomNodeNewArcDelete} onClick={handleHideNode} />
        </>}
      </NodeToolbar>
      
      <div className="w-full ">
        <label
          style={{
            fontSize: 13,
            fontWeight: "bold",

            color: data.nonAttivo?"#CCCCCC":"black",
            textAlign: "center",
          }}
        >
          {String(data.label)}
        </label>
        
      </div>
      <Handle
        className=".react-flow__handle "
        type="target"
        id="at"
        style={{ visibility: "hidden" }}
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Handle
        type="target"
        id="bt"
        position={Position.Bottom}
        style={{ visibility: "hidden" }}
        // style={{left: 10, visibility:"hidden" }}
        isConnectable={isConnectable}
      />
      <Handle
        type="target"
        id="ct"
        position={Position.Bottom}
        style={{ right: 10, visibility: "hidden" }}
        isConnectable={isConnectable}
      />

      <Handle
        type="source"
        position={Position.Bottom}
        style={{ visibility: "hidden" }}
        id="as"
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        id="bs"
        position={Position.Top}
        style={{ visibility: "hidden" }}
        isConnectable={isConnectable}
      />
    </div>
  );
}

export default CustomNode;
